<div class="main-container" fxLayoutGap="20px">
    <tv-header class="noprint" [sideNav]="sideNav"></tv-header>
    <mat-sidenav-container class="main-sidenav-container">
      <mat-sidenav #sideNav mode="over">
        <tv-menu [sideNav]="sideNav"></tv-menu>
      </mat-sidenav>
      <mat-sidenav-content>
        <div class="route-component">
            <!--The content below is only a placeholder and can be replaced.-->
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
    </mat-sidenav-container>
</div>
